import React from 'react';
import { Link, withRouter } from 'react-router-dom'
function Contact(){
    const text = "adasd"

    return(
       
        <div className="thanks">
          <h1>Contact Us</h1>

          <p>If you have any questions please email us – contact@pixelbyhand.com </p>
          <p><Link className="neop" to="/user-login/profile"><h2>Back To Profile</h2></Link></p>
         
      </div>
       
    )
}

export default withRouter(Contact)